import * as React from 'react';
import { useSelector } from 'react-redux';

// Utils
import { selectors } from '@src/shared/src';
import { isNotNilOrEmpty } from '@src/shared/src/util/general';
import { notify } from '@toolkit/util/app';
// Constants
import { NOTIF_TYPE } from '@src/shared/src/const/app';
// Models
import { BasketItemModel } from '@src/shared/src/models';
// Interfaces
import { IRootState } from '@src/store';

// TEMPORARY (lanes-planes/backend#14708). FlexLane (Koala CFAR) is quoted at prepare-finish, and a
// quote Koala refuses - or an API call that fails outright - leaves the booking intact but without a
// FlexLane contract. Nothing is shown when it works: the fee is internal at this step. During the
// testing phase a failure IS shown, in the backend's own untranslated words ("Koala Failed - 400"),
// so the team sees a refusal happen in staging instead of digging it out of Bugsnag. Delete this
// with the rest of the testing-phase surfacing.
//
// A warning rather than an error, and it renders nothing itself: the booking succeeded, so this must
// not read as a failed booking or take layout away from one.
export const ShowFlexLaneError:React.FC = () => {
  const basketItems = useSelector((state:IRootState) =>
    selectors.checkout.basketItems(state.checkout),
  );
  // The basket re-broadcasts on every change and each payload repeats the error, so without this the
  // same refusal stacks up a toast per broadcast. Keyed on the item AND the message, not the item
  // alone: a re-prepare quotes again and can fail differently, and that second reason is news.
  const notified = React.useRef(new Set<string>());

  React.useEffect(() => {
    basketItems
      .filter((item:BasketItemModel) => isNotNilOrEmpty(item.flexlaneError))
      .forEach((item:BasketItemModel) => {
        const seen = `${item.id}:${item.flexlaneError}`;
        if (notified.current.has(seen)) {
          return;
        }

        notified.current.add(seen);
        notify(item.flexlaneError, NOTIF_TYPE.WARNING, [], 0);
      });
  }, [basketItems]);

  return null;
};
